import createSvgIcon from "./utils/create_icon"

const TextSizeLarge = createSvgIcon(<path d="M5 4a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V6h5v12h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1V6h5v1a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1z" fill="currentColor" />, "TextSizeLarge")
export default TextSizeLarge
